// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".token-preview-modal[data-v-7fa3ea8e]{width:400px}", ""]);
// Exports
module.exports = exports;
